import React, { useRef, useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useUserInfo } from '@repository/auth/useUserInfo';
import useClickAway from '@utils/hooks/useClickOutside';
import classnames from 'classnames/bind';
import styles from '../positionFilter.module.scss';
const cx = classnames.bind(styles);

const fieldName = 'matchingYn';

const MatchingStatusFilter = () => {
  const [selectOptionAreaVisible, setSelectOptionAreaVisible] = useState(false);

  const { data: userInfo } = useUserInfo();
  const isLogin = !!userInfo?.id;

  const matchStateFilterRef = useRef<HTMLDivElement>(null);
  const { control } = useFormContext();

  const { field } = useController({
    control,
    name: fieldName,
    defaultValue: false,
  });

  const btnName = field.value ? '추천받음' : '추천상태';

  const onChangeStatus = () => {
    field.onChange(!field.value);
  };

  useClickAway(() => setSelectOptionAreaVisible(false), matchStateFilterRef);

  return (
    <div className={cx('selectWrap')} ref={matchStateFilterRef}>
      <a
        className={cx('btnSelect', { open: selectOptionAreaVisible }, { on: field.value })}
        onClick={() => setSelectOptionAreaVisible(!selectOptionAreaVisible)}
        role="button"
      >
        {btnName}
      </a>
      {selectOptionAreaVisible && (
        <div className={cx('selectOptionArea', 'matchState')}>
          <label className={cx('label')}>
            <input
              type="checkbox"
              className={cx('hidden', 'input')}
              disabled={!isLogin}
              checked={field.value}
              onChange={onChangeStatus}
            />
            <span className={cx('checkbox')} />
            추천 받음
          </label>
        </div>
      )}
    </div>
  );
};

export default MatchingStatusFilter;
